import axios from 'axios';
import config from '@assets/config.json'; // api 请求json

const state = {
  materialList: [], // 图片素材信息,
  materialVideoList: [], // 视频素材信息,
}
const mutations = {
  setMaterial(state, data) {
    state.materialList = data;
  },
  setVideoMaterial(state, data) {
    state.materialVideoList = data;
  },
}
const getters = {
  getMaterial: state => {
    return state.materialList;
  },
  getVideoMaterial: state => {
    return state.materialVideoList;
  },
}
const actions = {
  getMaterial({ rootState, commit }, opt) { // 获取图片素材信息
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/albumPhoto/GetByCompId`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  getAllMaterial({ rootState, commit }, opt) { // 获取全部图片素材信息
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/albumPhoto/GetByCompId`, opt, rootState.header).then(data => {
        if (data.data) {
          axios.post(`${config.api.reqApi}/api/albumPhoto/GetByCompId`, { "CompId": data.data.items[0].compId, "pageSize": data.data.totalCount, }, rootState.header).then(data => {
            if (data.data) {
              commit('setMaterial', data.data);
              resolve(data.data);
            }
          }).catch((err) => {
            console.log(err.response.data);
          });
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },

  addMaterial({ rootState }, opt) { // 新增图片素材
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/albumPhoto`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  editMaterial({ rootState }, id) { // 删除图片素材
    return new Promise((resolve, reject) => {
      axios.put(`${config.api.reqApi}/api/albumPhoto?id=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  delMaterial({ rootState }, id) { // 删除图片素材
    return new Promise((resolve, reject) => {
      axios.delete(`${config.api.reqApi}/api/albumPhoto?id=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },

  getvideoMaterial({ rootState, commit }, opt) { // 获取视频素材信息
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/video/GetByCompId`, opt, rootState.header).then(data => {
        if (data.data) {
          commit('setVideoMaterial', data.data);
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  getAllvideoMaterial({ rootState, commit }, opt) { // 获取全部视频素材信息
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/video/GetByCompId`, opt, rootState.header).then(data => {
        if (data.data) {
          axios.post(`${config.api.reqApi}/api/video/GetByCompId`, { "CompId": data.data.items[0].compId, "pageSize": data.data.totalCount, }, rootState.header).then(data => {
            if (data.data) {
              commit('setMaterial', data.data);
              resolve(data.data);
            }
          }).catch((err) => {
            console.log(err.response.data);
          });
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  addvideoMaterial({ rootState }, opt) { // 新增视频素材
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/video`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  editvideoMaterial({ rootState }, opt) { // 编辑视频素材
    return new Promise((resolve, reject) => {
      axios.put(`${config.api.reqApi}/api/video`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  delvideoMaterial({ rootState }, id) { // 删除视频素材
    return new Promise((resolve, reject) => {
      axios.delete(`${config.api.reqApi}/api/video?id=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
} 